import { render, staticRenderFns } from "./SlotWithConfirm.vue?vue&type=template&id=423cbd22&scoped=true"
import script from "./SlotWithConfirm.vue?vue&type=script&lang=ts"
export * from "./SlotWithConfirm.vue?vue&type=script&lang=ts"
import style0 from "./SlotWithConfirm.vue?vue&type=style&index=0&id=423cbd22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "423cbd22",
  null
  
)

export default component.exports